import React from 'react';
import classes from './style.module.css'

const Spinner = () => (
    <div className={classes.Loader}>Loading...</div>
);

export default Spinner;